/**
 * A noop padding strategy.
 */
export var NoPadding = {
  pad: function pad() {},
  unpad: function unpad() {}
};